import React from 'react';
import { FormattedMessage } from 'react-intl';

import { IBasicStyledProps } from '@notino/react-styleguide-v20';

import { CartFinalPriceRow } from '@styles/cartComponents';
import { ReactFCV } from '@types';
import { CypressTestNamespace } from '@utils/test';

import { useCartPageContext } from '../../context';
import { messages } from '../../messages';

export const FinalPriceRowWrapper: ReactFCV<IBasicStyledProps> = ({ ...rest }) => {
  const {
    state: {
      pricesSummary: { priceItemSummary },
    },
  } = useCartPageContext();

  return (
    <CartFinalPriceRow
      data-testid="final-price-row"
      dataTestId={CypressTestNamespace.ECartPagePrice.TOTAL_PRICE}
      priceFontSize={'1.625rem'}
      price={priceItemSummary}
      {...rest}>
      <FormattedMessage {...messages.totalPrice} />
    </CartFinalPriceRow>
  );
};
